"use client";

import { c as _c } from "react/compiler-runtime";
import AIBadge from "@/components/ui/ai-badge";
import { useAIChatContext } from "./contexts";
import { ThinkingIndicator } from "./thinking-indicator";

/**
 * Default footer for AIChatMessages — renders the thinking indicator,
 * streaming text cursor, and error display.
 * Compose as `<AIChat.Messages footer={<AIChat.Footer />}>`.
 */
export function AIChatFooter() {
  const $ = _c(13);
  const {
    state
  } = useAIChatContext();
  const {
    isStreaming,
    streamingText,
    error,
    activityLabel
  } = state;
  let t0;
  if ($[0] !== activityLabel || $[1] !== isStreaming || $[2] !== streamingText) {
    t0 = isStreaming && !streamingText && <div className="mt-2 flex items-center gap-2 py-2"><div className="flex size-6 shrink-0 items-center justify-center rounded-full bg-primary/10"><AIBadge size={14} className="mr-0" /></div><ThinkingIndicator label={activityLabel ? `Checking ${activityLabel}...` : undefined} /></div>;
    $[0] = activityLabel;
    $[1] = isStreaming;
    $[2] = streamingText;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== isStreaming || $[5] !== streamingText) {
    t1 = streamingText && <div className="mt-2"><p className="text-body leading-relaxed text-foreground">{streamingText}{isStreaming && <span className="ml-0.5 inline-block h-3 w-0.5 animate-pulse bg-primary" />}</p></div>;
    $[4] = isStreaming;
    $[5] = streamingText;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== error) {
    t2 = error && <p className="mt-2 text-body text-status-error-text">{error}</p>;
    $[7] = error;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}